// Media files in the page: object URLs for stored files, made once per file and kept for the
// session (files are immutable, since a key is a hash of the contents).

import { useEffect, useState } from 'react';
import * as db from '../model/db';

const urls = new Map<string, Promise<string | undefined>>();

export function fileUrl(key: string): Promise<string | undefined> {
  let p = urls.get(key);
  if (!p) {
    p = db.getFile(key).then((b) => (b ? URL.createObjectURL(b) : undefined));
    urls.set(key, p);
    // A miss might be a file that's still being saved; try again next time.
    p.then((u) => !u && urls.delete(key));
  }
  return p;
}

/** The URL of a stored file, or undefined while it loads (or if it's missing). */
export function useFileUrl(key: string | undefined): { url?: string; missing: boolean } {
  const [state, setState] = useState<{ key?: string; url?: string; missing: boolean }>({ missing: false });
  useEffect(() => {
    if (!key) return;
    let live = true;
    fileUrl(key).then((url) => live && setState({ key, url, missing: !url }));
    return () => {
      live = false;
    };
  }, [key]);
  return state.key === key ? { url: state.url, missing: state.missing } : { missing: false };
}
